import { useResultPageStore } from "../stores/ResultPageStore";
import axios from 'axios';
import { JOB_STATE_UPLOADING, JOB_STATE_UPLOADING_COMPLETE } from "../const/job.const";
import OutputSelectionManager from "../manager/OutputSelectionManager";
import Analytics from "./Analytics";

let selectedOutputs = [];
let selectedJob = null;

function _getToken(msalInstance) {
    const loginRequest = {
        scopes: ["Files.ReadWrite.All"],
        prompt: "select_account",
        responseType: "token",
        responseMode: "fragment"
    };

    msalInstance.loginPopup(loginRequest).then(response => {
        if (response.error !== undefined) {
            throw (response);
        }
        _handleAuthResult(response.accessToken);
    });
}

function _handleAuthResult(authResult) {
    _saveToDrive(authResult);
}

async function _saveToDrive(accessToken) {
    let store = useResultPageStore();
    let payload = [];

    selectedOutputs.forEach((output) => {
        payload.push({
            id: output.id,
            url: output.uri.replace('download-file', 'onedrive-uploader'),
            data: {
                oauthToken: accessToken,
            }
        })
    });

    for (const uploadItem of payload) {
        let output = store.getOutputById(selectedJob.id, uploadItem.id);
        output.status = 'uploading-init';
    }

    for (const uploadItem of payload) {
        let output = store.getOutputById(selectedJob.id, uploadItem.id);
        output.status = 'uploading';

        let form = new FormData();
        form.append('oauthToken', uploadItem.data.oauthToken);

        var uploadUrl = uploadItem.url.replace('/v2', '');

        await axios.post(`${uploadUrl}?oauthToken=${accessToken}`, form, {
            withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
          
        output.status = 'uploading-done';
    }

    Analytics.send('result_onedrive', 'upload_done');
    selectedJob.state = JOB_STATE_UPLOADING_COMPLETE;
}

class Onedrive {
    listener = false;

    constructor() {
    }

    async uploadJob(job) {
        Analytics.send('result_onedrive', 'upload_job', job);

        selectedOutputs = job.apiJob.output;
        selectedJob = job;

        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'onedrive';

        this._startMicrosoftFlow();
    }

    async uploadSelectedOutputs(job) {
        Analytics.send('result_onedrive', 'upload_selected_outputs', job);

        selectedOutputs = OutputSelectionManager.getSelectedOutputs(job);
        selectedJob = job;

        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'onedrive';

        this._startMicrosoftFlow();
    }

    _startMicrosoftFlow() {
        if (sessionStorage.getItem('PLAYWRIGHT') === 'true') {
            //return;
        }

        let that = this;
        $.when(
            $.cachedScript('https://alcdn.msauth.net/browser/2.30.0/js/msal-browser.min.js')
        ).done(function () {
            that._initClient();
        });
    }

    _initClient() {
        const msalConfig = {
            auth: {
                clientId: window.sat.onedriveConfig.clientId,
                authority: "https://login.microsoftonline.com/common",
                redirectUri: window.location.origin + '/result',
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: "sessionStorage"
            }
        };

        const msalInstance = new msal.PublicClientApplication(msalConfig);
        _getToken(msalInstance);
    }

    _handleAuthResult(authResult) {
        var accessToken = null;
        try {
            accessToken = authResult.access_token;
        } catch (e) {
        }
        this.saveToDrive(accessToken);
    }

    saveToDrive(accessToken) {
        var data = {
            url: rsUrl,
            data: {
                oauthToken: accessToken,
            },
        };
    }
}

export default new Onedrive();